import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as actions from './redux/actions';

import ClientSidebar from './ClientSidebar';
import { extractPromptDataFromUrl, savePendingPrompt } from '../../common/utils/prompt-storage';
const toastrStyle = {
  width: 'auto',
  minWidth: '15vw',
};
export class App extends Component {
  static propTypes = {
    home: PropTypes.object.isRequired,
    login: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

   componentDidMount() {
    this.getIncomingPrompt();
  }
  componentDidUpdate(prevProps) {
    if (this.props.location?.search !== prevProps.location?.search) {
      this.getIncomingPrompt();
    }
  }


  getIncomingPrompt = () => {
    const {location, history} = this.props;
    const search = location?.search || window.location.search;
    const promptData = extractPromptDataFromUrl(search);

    if(promptData){
      // 1. Save to persistent storage
      savePendingPrompt(promptData);


      // 2. Cleaning the URL so that this prevents the user from accidentally re-triggering if they hit browser reload
      if (history && location) {
        history.replace({
          pathname: location.pathname,
          search: '',
        });
      }
    }
  }

  render() {
    const { login, history, children, location } = this.props;
    const { token } = login;
    const { pathname } = location;

    const showSidebar = pathname !== '/software-development-cost-calculator';
    return (
      <div className="home-app">
        <div className="page-container">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            style={toastrStyle}
          />
          {token && showSidebar ? <ClientSidebar history={history} /> : ''}
          {children}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    home: state.home,
    login: state.login,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
